import React, { memo } from 'react';
import { Modal } from 'react-bootstrap';
import { useModalNotifications } from '../hooks/useNotifications';
import NotificationListPremium from './NotificationListPremium';
import Button from '../../common/form/button';

const ObligatoryModal = memo(() => {
  const {
    notifications,
    showModal,
    hasNotifications,
    isObligatory,
    markAllAsRead,
    closeModal,
    isMarkingAsRead,
    markAsRead,
  } = useModalNotifications();

  const handleClose = () => {
    if (isObligatory && hasNotifications) {
      return;
    }
    closeModal();
  };

  const handleMarkAllAsRead = async () => {
    try {
      await markAllAsRead();
    } catch (error) {
      console.error('Erro ao marcar todas como lidas:', error);
    }
  };

  if (!showModal) return null;

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      aria-labelledby="obligatoryModalLabel"
      centered
      backdrop={isObligatory && hasNotifications ? 'static' : true}
      keyboard={!(isObligatory && hasNotifications)}
      dialogClassName="notif-modal-premium-dialog"
      className="notif-modal-premium"
      style={{ zIndex: 1050 }}
    >
      <div className="notif-modal-premium-shell">
        <div className="notif-modal-premium-header">
          <h4 id="obligatoryModalLabel">
            <i className="fa fa-bell" />
            {hasNotifications
              ? notifications.length === 1
                ? '1 Notificação'
                : `${notifications.length} Notificações`
              : 'Notificações'}
          </h4>
          {!(isObligatory && hasNotifications) && (
            <button
              type="button"
              className="notif-modal-premium-close"
              onClick={handleClose}
              aria-label="Fechar"
            >
              <i className="fa fa-times" />
            </button>
          )}
        </div>

        {isObligatory && hasNotifications && (
          <div className="notif-modal-obligatory-banner">
            <i className="fa fa-info-circle" />
            <strong>Atenção:</strong> estas notificações devem ser lidas antes de continuar.
          </div>
        )}

        <div className="notif-modal-premium-body">
          <NotificationListPremium
            notifications={notifications}
            onMarkAsRead={markAsRead}
            isMarkingAsRead={isMarkingAsRead}
            onNavigateAway={closeModal}
          />
        </div>

        <div className="notif-modal-premium-footer">
          {hasNotifications && (
            <Button
              type="button"
              className="primary"
              icon="check-double"
              label={isMarkingAsRead ? 'Processando...' : 'Marcar todas como lidas'}
              onClick={handleMarkAllAsRead}
              disabled={isMarkingAsRead}
            />
          )}
          {!(isObligatory && hasNotifications) && (
            <Button type="button" className="default" icon="close" label="Fechar" onClick={handleClose} />
          )}
        </div>
      </div>
    </Modal>
  );
});

ObligatoryModal.displayName = 'ObligatoryModal';

export default ObligatoryModal;
